import axios from 'axios';
import apiConfig from "../apiConfig.ts"

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

// Helper function to get form data headers
const getFormDataHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    ...(token && { Authorization: `Bearer ${token}` })
    // Don't set Content-Type for FormData, let axios handle it
  };
};

export const giftItemApi = {
  // Get all gift items with filters
  getAllGiftItems: async (params = {}) => {
    try {
      const response = await axios.get(`${apiConfig.apiBaseURL}/giftItem/get-all-gift-items`, {
        headers: getAuthHeaders(),
        params
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get single gift item
  getSingleGiftItem: async (giftItemId) => {
    try {
      const response = await axios.get(`${apiConfig.apiBaseURL}/giftItem/get-gift-item/${giftItemId}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Create gift item
  createGiftItem: async (formData) => {
    try {
      const response = await axios.post(`${apiConfig.apiBaseURL}/giftItem/create-gift-item`, formData, {
        headers: getFormDataHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Update gift item
  updateGiftItem: async (giftItemId, formData) => {
    try {
      const response = await axios.put(`${apiConfig.apiBaseURL}/giftItem/update-gift-item/${giftItemId}`, formData, {
        headers: getFormDataHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Soft delete gift item
  softDeleteGiftItem: async (giftItemId) => {
    try {
      const response = await axios.delete(`${apiConfig.apiBaseURL}/giftItem/soft-delete-gift-item/${giftItemId}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Update gift item status
  updateGiftItemStatus: async (giftItemId, isActive) => {
    try {
      const response = await axios.put(`${apiConfig.apiBaseURL}/giftItem/update-gift-item-status/${giftItemId}`, 
        { isActive }, 
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};